module.exports = {
    plan: 'Omni-D',
    startDate: new Date(2016, 11, 1, 0, 0, 0, 0),
    endDate: new Date(2017, 11, 1, 0, 0, 0, 0),
    cloudBandwidthUsed: 220 * 1024 * 1024 * 1024, // 100 GB
    cloudBandwidthTotal: 200 * 1024 * 1024 * 1024, // 200 GB
    cloudStorageUsed: 4 * 1024 * 1024 * 1024, // 1 GB
    cloudStorageTotal: 50 * 1024 * 1024 * 1024 // 50 GB
};



// WEBPACK FOOTER //
// ./modules/license/services/licenseOverviewService.cloudSubscriptionSummary.mock.js